import {Getters} from "vuex-smart-module";
import ProductState from "@/store/modules/product/product-state";
import ProductData from "@/http/data/product-data";
import _ from "lodash";

export default class ProductGetters extends Getters<ProductState> {
    get productsByCategoryName(): _.Dictionary<ProductData[]> {
        return _.groupBy(this.state.products, product => product.category);
    }
}